if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const cartItem = document.querySelector('.header__icon--cart');
        if (cartNotification && cartItem) cartNotification.setActiveElement(this.openedBy);
        setTimeout(() => {this.modalContent.innerHTML = '';},300);

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.productList = this.productElement.querySelector('.product__media-list');
            this.productList.classList.add('slider--desktop');
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        const stickyCart = this.productElement.querySelectorAll('sticky-cart');
        if (stickyCart) stickyCart.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 487px, (min-width: 750px) calc((100vw - 9rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('487px', '450px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('487px', '430px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

if (!customElements.get('custom-variant-drawer')) {
  customElements.define(
    'custom-variant-drawer',
    class CustomVariantDrawer extends HTMLElement {
      constructor() {
        super();
        this.closeButton = this.querySelector('.custom-variant-drawer__close');
        this.closeButton?.addEventListener('click', this.hide.bind(this));

        this.optionGroups = Array.from(this.querySelectorAll('.custom-variant-drawer__option-group'));
        this.pills = this.querySelectorAll('.variant-pill');
        this.pills.forEach((pill) => {
          pill.addEventListener('click', this.onOptionClick.bind(this));
        });

        const jsonScript = this.querySelector('.custom-variant-drawer__json');
        this.variants = jsonScript ? JSON.parse(jsonScript.textContent) : [];
        this.selectedOptions = new Array(this.optionGroups.length).fill(null);
        this.currentVariant = null;

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      show(opener) {
        this.openedBy = opener;
        document.body.appendChild(this); // Teleport to body to escape overflow: hidden and center correctly
        
        // Force a reflow so transition works after appending
        this.offsetHeight;
        
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }

      hide() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        if (this.openedBy) this.openedBy.focus();
      }

      onOptionClick(event) {
        const pill = event.currentTarget;
        const group = pill.closest('.custom-variant-drawer__option-group');
        const groupIndex = parseInt(group.dataset.optionIndex, 10);
        
        // Update active state in group
        group.querySelectorAll('.variant-pill').forEach(p => p.classList.remove('active'));
        pill.classList.add('active');
        
        // Update selected options
        this.selectedOptions[groupIndex] = pill.dataset.value;
        this.updateVariant(pill);
      }

      updateVariant(pill) {
        if (this.selectedOptions.includes(null)) {
          return;
        }

        this.currentVariant = this.variants.find(variant => {
          return variant.options.every((opt, index) => opt === this.selectedOptions[index]);
        });

        if (this.currentVariant && this.currentVariant.available) {
           this.addToCart(pill);
        } else if (this.currentVariant && !this.currentVariant.available) {
           pill.classList.add('sold-out');
           const origText = pill.innerText;
           pill.innerText = window.variantStrings?.soldOut || 'Sold Out';
           setTimeout(() => { pill.innerText = origText; pill.classList.remove('sold-out'); }, 2000);
        }
      }

      addToCart(pill) {
        if (!this.currentVariant || !this.currentVariant.available) return;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.currentVariant.id);
        formData.append('quantity', 1);
        
        const cartNotification = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (cartNotification && cartNotification.getSectionsToRender) {
          const sectionsToRender = cartNotification.getSectionsToRender().map((s) => s.id).join(',');
          formData.append('sections', sectionsToRender);
        } else {
          formData.append('sections', 'cart-icon-bubble,cart-drawer,cart-notification');
        }
        formData.append('sections_url', window.location.pathname);

        config.body = formData;

        pill.classList.add('loading');
        pill.innerHTML += `<span class="loading-overlay__spinner" style="display:inline-block; width:1.4rem; height:1.4rem; margin-left: 0.5rem; vertical-align: middle;"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></span>`;
        
        // Show Toast
        let toast = document.getElementById('custom-cart-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.id = 'custom-cart-toast';
          toast.style.cssText = 'position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%); background: var(--color-foreground, #000); color: var(--color-background, #fff); padding: 12px 24px; border-radius: 30px; z-index: 9999; font-size: 14px; opacity: 0; transition: opacity 0.3s ease; pointer-events: none;';
          document.body.appendChild(toast);
        }
        toast.textContent = 'Adding to cart...';
        toast.style.opacity = '1';

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
             this.hide();
             
             // Reset options for next time
             this.selectedOptions.fill(null);
             this.pills.forEach(p => p.classList.remove('active'));
             
             const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
             if (cartDrawer && cartDrawer.getSectionsToRender) {
                cartDrawer.getSectionsToRender().forEach((section) => {
                  const elementToReplace = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
                  if (elementToReplace && response.sections && response.sections[section.id]) {
                    const parsedHTML = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
                    const replacementElement = parsedHTML.querySelector(section.selector || '.shopify-section');
                    if (replacementElement) {
                      elementToReplace.innerHTML = replacementElement.innerHTML;
                      
                      // Remove is-empty class to reveal contents
                      const drawer = elementToReplace.closest('cart-drawer');
                      if (drawer) {
                         drawer.classList.remove('is-empty');
                      }
                      const drawerInner = elementToReplace.querySelector('.drawer__inner');
                      if (drawerInner) {
                         drawerInner.classList.remove('is-empty');
                      }
                    }
                  }
                });
                if (cartDrawer.open) cartDrawer.open();
             }
             
             toast.textContent = 'Added to cart!';
             setTimeout(() => { toast.style.opacity = '0'; }, 3000);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            pill.classList.remove('loading');
            pill.textContent = origText;
          });
      }
    }
  );
}